(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aa-pdp-buybox"] && !Shopify.designMode) return;
  try {
    
  /**
   * <aa-gallery> — thumbnail picks the shot.
   *
   * Every shot is already in the DOM and only opacity changes, so switching
   * costs nothing and never waits on a decode.
   */
  class AAGallery extends HTMLElement {
    connectedCallback() {
      this.shots = [...this.querySelectorAll('[data-aa-gallery-shot]')];
      this.picks = [...this.querySelectorAll('[data-aa-gallery-pick]')];
      this.frame = this.querySelector('.aa-pdpbb__frame');
      this.strip = this.querySelector('.aa-pdpbb__thumbs');
      if (!this.shots.length) return;

      this.addEventListener('click', (event) => {
        const pick = event.target.closest('[data-aa-gallery-pick]');
        if (!pick) return;
        this.show(Number(pick.dataset.aaGalleryPick));
      });

      // Swiping is the other way in, and the strip has to follow it.
      this.frame?.addEventListener('scroll', () => {
        if (this.settling) return;
        this.settling = requestAnimationFrame(() => {
          this.settling = null;
          const width = this.frame.clientWidth;
          if (!width) return;
          this.mark(Math.round(this.frame.scrollLeft / width));
        });
      }, { passive: true });
    }

    /**
     * Whether the frame is laid out as a track. Asked of the layout rather than
     * of a media query, so the breakpoint lives in one place — the stylesheet —
     * and this cannot drift out of step with it.
     */
    get isTrack() {
      return !!this.frame && this.frame.scrollWidth > this.frame.clientWidth + 1;
    }

    show(index) {
      if (this.isTrack) {
        // Let the scroll handler do the marking, so a tap and a swipe end in
        // exactly the same state.
        this.frame.scrollTo({ left: index * this.frame.clientWidth, behavior: 'smooth' });
        return;
      }
      this.mark(index);
    }

    mark(index) {
      if (index === this.current) return;
      this.current = index;

      this.shots.forEach((shot, i) => shot.classList.toggle('is-current', i === index));
      this.picks.forEach((pick, i) => {
        const on = i === index;
        pick.classList.toggle('is-current', on);
        pick.setAttribute('aria-current', on ? 'true' : 'false');
        // The strip scrolls too on a phone; keep the marked thumb in sight.
        if (on && this.strip && this.strip.scrollWidth > this.strip.clientWidth + 1) {
          this.strip.scrollTo({
            left: pick.offsetLeft - (this.strip.clientWidth - pick.offsetWidth) / 2,
            behavior: 'smooth',
          });
        }
      });
    }
  }

  if (!customElements.get('aa-gallery')) customElements.define('aa-gallery', AAGallery);

  /**
   * The nutrition panel. It lives in the gallery because it is the gallery's
   * last shot — the button is a shortcut to an image the shopper could also
   * reach by paging through the thumbnails.
   */
  {
    const dialog = document.getElementById('aa-pdp-nutrition');
    const open = document.querySelector('[data-aa-facts]');

    if (dialog && open && dialog.showModal) {
      open.addEventListener('click', () => dialog.showModal());

      dialog.addEventListener('click', (event) => {
        // A click on the backdrop lands on the dialog itself; one on the image
        // or the close button does not.
        if (event.target === dialog || event.target.closest('[data-aa-facts-close]')) {
          dialog.close();
        }
      });
    } else if (open) {
      // No dialog support: send them to the shot instead of leaving a button
      // that does nothing.
      open.addEventListener('click', () => {
        const picks = document.querySelectorAll('[data-aa-gallery-pick]');
        picks[picks.length - 1]?.click();
      });
    }
  }

  /**
   * <aa-buy> — the pickers drive the cart form.
   *
   * Quantity and plan live in hidden inputs rather than in the visible
   * controls, so the form posts exactly what Shopify expects and the styling of
   * the pickers is free. Quantity is the adults count times the tier's own
   * multiplier — a three month tier ships three packs per adult.
   */
  class AABuy extends HTMLElement {
    connectedCallback() {
      this.qtyInput = this.querySelector('[data-aa-cart-qty]');
      this.planInput = this.querySelector('[data-aa-cart-plan]');
      this.qtyButtons = [...this.querySelectorAll('[data-aa-qty]')];
      this.planRadios = [...this.querySelectorAll('.aa-pdpbb__plan-radio')];
      if (!this.qtyInput || !this.planInput) return;

      // Whichever option the markup marked, not always the first — a page can
      // open on 2 if that is the household it is written for.
      const marked = this.qtyButtons.find((b) => b.classList.contains('is-current'));
      this.adults = Number(marked && marked.dataset.aaQty) || 1;

      this.addEventListener('click', (event) => {
        const qty = event.target.closest('[data-aa-qty]');
        if (qty) {
          this.adults = Number(qty.dataset.aaQty) || 1;
          this.qtyButtons.forEach((b) => {
            const on = b === qty;
            b.classList.toggle('is-current', on);
            b.setAttribute('aria-checked', on ? 'true' : 'false');
          });
          this.sync();
        }

        // A one-off overrides the tier for this submit only.
        if (event.target.closest('[data-aa-onetime]')) {
          this.planInput.value = '';
          this.qtyInput.value = String(this.adults);
        }
      });

      this.addEventListener('change', (event) => {
        if (!event.target.matches('.aa-pdpbb__plan-radio')) return;
        this.planRadios.forEach((radio) => {
          radio.closest('.aa-pdpbb__plan').classList.toggle('is-current', radio.checked);
        });
        this.sync();
      });

      this.form = this.querySelector('.aa-pdpbb__form');
      this.button = this.querySelector('[data-aa-atc]');
      this.error = this.querySelector('[data-aa-cart-error]');
      if (this.form) this.form.addEventListener('submit', (event) => this.submit(event));

      this.sync();
    }

    /**
     * Add the chosen line, then go to checkout with it.
     *
     * The form's return_to already does this without script. Adding through
     * the API first buys one thing: a refusal comes back as JSON and can be
     * read out in the rail, where a plain submit would navigate away to an
     * error page and lose the shopper's configuration.
     *
     * The button stays busy through the redirect. Clearing it would invite a
     * second click during the navigation, and a second click is a second line.
     */
    async submit(event) {
      event.preventDefault();
      if (this.busy) return;
      this.busy = true;
      this.button?.setAttribute('aria-busy', 'true');
      this.showError('');

      const root = window.Shopify?.routes?.root ?? '/';

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(this.form),
        });
        const data = await response.json();

        if (!response.ok) {
          // 422 carries the reason — a plan the variant has not got, or a
          // quantity past what is in stock. Say it rather than fail silently.
          this.showError(data.description || data.message || 'This could not be added.');
          this.release();
          return;
        }

        window.location.assign(`${root}checkout`);
      } catch {
        // The network, not the cart. Fall back to the plain post, which carries
        // the same return_to and ends in the same place.
        this.form.submit();
      }
    }

    release() {
      this.busy = false;
      this.button?.removeAttribute('aria-busy');
    }

    showError(message) {
      if (!this.error) return;
      this.error.textContent = message;
      this.error.hidden = !message;
    }

    sync() {
      const chosen = this.planRadios.find((radio) => radio.checked);
      const packs = Number(chosen && chosen.dataset.aaPlanQty) || 1;
      this.qtyInput.value = String(this.adults * packs);
      // An empty value posts as a one-off, which is what a tier with no plan is.
      this.planInput.value = (chosen && chosen.value) || '';
    }
  }

  if (!customElements.get('aa-buy')) customElements.define('aa-buy', AABuy);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ind-new-blog-hero"] && !Shopify.designMode) return;
  try {
    
  /* Share button: Web Share API with copy-link fallback */
  (function () {
    var btn = document.querySelector('.js-share');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-url');
      var title = btn.getAttribute('data-title');

      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
        return;
      }

      var label = btn.querySelector('.ind-new-blog-hero__share-label');
      var original = label ? label.textContent : '';

      function flash(msg) {
        if (!label) return;
        label.textContent = msg;
        setTimeout(function () { label.textContent = original; }, 1500);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          flash('Link copied');
        }).catch(function () {
          flash('Copy failed');
        });
      } else {
        flash(url);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
